module.exports = __webpack_public_path__ + "img/file-queue.66ac4eed.svg";